export default __webpack_public_path__ + "static/media/imagefour.0d2d9916.gif";